import { createContext, useContext } from 'react';

interface MediaSlidesGalleryContextType {
  id?: string;
  open: boolean;
  toggle: () => void;
}
const MediaSlidesGalleryContext = createContext<MediaSlidesGalleryContextType>({} as MediaSlidesGalleryContextType);

export const useMediaSlidesGalleryContext = () => {
  return useContext(MediaSlidesGalleryContext);
};

export default MediaSlidesGalleryContext;
